// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wwh-","colBig":"styles_colBig__2K5ah","colSmall":"styles_colSmall__3Eo2v"};